import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
// import themeReducer from "../utils/theme/slice";
import rootReducer from "./reducers";
import rootSaga from "./sagas";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
const sagaMiddleware = createSagaMiddleware();

// Alert popups are per-page UI state. Persisting them made an undismissed popup reappear
// on every reload and in every other tab (e.g. "reset link sent" on the reset-link page).
const TRANSIENT_KEYS = ["message", "error"];

const persistConfig = {
  key: "equity-edge-user-root",
  storage,
  blacklist: TRANSIENT_KEYS,
  // The blacklist only stops writes; also drop alerts saved before it existed
  migrate: (state) => {
    if (!state) return Promise.resolve(state);
    const rest = { ...state };
    TRANSIENT_KEYS.forEach((key) => delete rest[key]);
    return Promise.resolve(rest);
  },
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(sagaMiddleware),
});
export const persistor = persistStore(store);
export const clearPersistedData = async () => {
  await persistor.purge();
};

sagaMiddleware.run(rootSaga);
